<template>
    <div style="padding: 20px">
        <v-overlay :value="showOverlay">
            <v-progress-circular indeterminate size="64"></v-progress-circular>
        </v-overlay>
        <v-card>
            <v-toolbar class="indigo white--text" dense primary-title>
                <v-toolbar-title
                    >Dettaglio Documento Trasporto
                    {{ num_ddt }}</v-toolbar-title
                >

                <v-spacer></v-spacer>

                <v-tooltip bottom>
                    <template v-slot:activator="{ on }">
                        <v-btn
                            class="mx-1"
                            v-on="on"
                            small
                            elevation="1"
                            @click="aggregate()"
                        >
                            <v-icon color="primary"> mdi-call-merge </v-icon>
                        </v-btn>
                    </template>
                    <span>Aggrega</span>
                </v-tooltip>

                <v-tooltip bottom>
                    <template v-slot:activator="{ on }">
                        <v-btn
                            class="mx-1"
                            v-on="on"
                            small
                            elevation="1"
                            @click="printAll()"
                        >
                            <v-icon color="primary"> mdi-printer </v-icon>
                        </v-btn>
                    </template>
                    <span>Stampa Etichette</span>
                </v-tooltip>

                <v-tooltip bottom>
                    <template v-slot:activator="{ on }">
                        <v-btn
                            class="mx-1"
                            v-on="on"
                            small
                            elevation="1"
                            @click="assignUbicazioni"
                        >
                            <v-icon color="primary"> mdi-warehouse</v-icon>
                        </v-btn>
                    </template>
                    <span>Assegnazione Ubicazioni</span>
                </v-tooltip>

                <v-tooltip bottom>
                    <template v-slot:activator="{ on }">
                        <v-btn
                            :disabled="qntErr"
                            class="mx-1"
                            v-on="on"
                            small
                            elevation="1"
                            @click="setAllMovimenti"
                        >
                            <v-icon color="success"> mdi-check-all</v-icon>
                        </v-btn>
                    </template>
                    <span>Conferma Tutti gli Ubicazioni</span>
                </v-tooltip>

                <v-spacer></v-spacer>

                <v-tooltip bottom>
                    <template v-slot:activator="{ on }">
                        <v-btn
                            v-on="on"
                            small
                            elevation="1"
                            @click="showFilter"
                        >
                            <v-icon color="purple"> mdi-filter</v-icon>
                        </v-btn>
                    </template>
                    <span>Filtri</span>
                </v-tooltip>

                <v-spacer></v-spacer>

                <v-tooltip bottom>
                    <template v-slot:activator="{ on }">
                        <v-btn
                            v-on="on"
                            small
                            elevation="1"
                            @click="$router.push('/home/DDT')"
                        >
                            <v-icon class="error--text">
                                mdi-keyboard-backspace
                            </v-icon>
                        </v-btn>
                    </template>
                    <span>Indietro</span>
                </v-tooltip>
            </v-toolbar>

            <v-progress-linear
                indeterminate
                color="cyan"
                v-if="loading"
                id="progress"
            >
            </v-progress-linear>

            <v-row v-if="filterVisible" class="ma-1">
                <v-col class="flex-grow-1 flex-shrink-0">
                    <v-autocomplete
                        dense
                        outlined
                        label="codice articolo"
                        v-model="filtroCod"
                        :items="codici"
                        @change="changeFilters"
                    >
                    </v-autocomplete>
                </v-col>
                <v-col class="flex-grow-1 flex-shrink-0">
                    <v-autocomplete
                        dense
                        outlined
                        label="stato"
                        v-model="filtroStato"
                        :items="stati"
                        @change="changeFilters"
                    >
                    </v-autocomplete>
                </v-col>
            </v-row>

            <v-card-text>
                <v-data-table
                    ref="DDTTable"
                    :items="filterVisible ? filtered : listDDT"
                    :headers="headers"
                    :expanded.sync="expandedItems"
                    :key="key"
                    item-key="id_documento_dettaglio"
                    show-expand
                >
                    <template v-slot:[`item.aggrega`]="{ item }">
                        <v-col>
                            <v-checkbox
                                dense
                                v-model="item.aggregaFlag"
                            ></v-checkbox>
                        </v-col>
                    </template>
                    <template v-slot:[`item.stampa`]="{ item }">
                        <v-tooltip bottom>
                            <template v-slot:activator="{ on }">
                                <v-btn
                                    class="mx-1"
                                    v-on="on"
                                    small
                                    elevation="1"
                                    @click="printRow(item)"
                                >
                                    <v-icon color="primary">
                                        mdi-printer
                                    </v-icon>
                                </v-btn>
                            </template>
                            <span>Stampa Etichetta</span>
                        </v-tooltip>
                    </template>
                    <template v-slot:[`item.qntPack`]="{ item }">
                        <v-col>
                            {{ packTot(item) }}
                        </v-col>
                    </template>
                    <template v-slot:[`item.stato`]="{ item }">
                        <v-tooltip bottom>
                            <template v-slot:activator="{ on }">
                                <v-icon
                                    :color="
                                        item.inMagazzino == 0
                                            ? stateIcons[0].color
                                            : item.inMagazzino < item.quantita
                                            ? stateIcons[1].color
                                            : stateIcons[2].color
                                    "
                                    v-on="on"
                                >
                                    {{
                    item.inMagazzino == 0
                      ? stateIcons[0].icon
                      : item.inMagazzino &lt; item.quantita
                      ? stateIcons[1].icon
                      : stateIcons[2].icon
                                    }}
                                </v-icon>
                            </template>
                            <span>{{
                item.inMagazzino == 0
                  ? stateIcons[0].desc
                  : item.inMagazzino &lt; item.quantita
                  ? stateIcons[1].desc
                  : stateIcons[2].desc
                            }}</span>
                        </v-tooltip>
                    </template>
                    <template v-slot:expanded-item="{ headers, item }">
                        <td
                            :colspan="headers.length"
                            class="pa-0"
                            style="background-color: white"
                        >
                            <v-row v-if="qntErr">
                                <v-col class="error--text">
                                    Errore: La quantita nei contenitori è
                                    maggiore della quantita nel documento
                                    trasporto
                                </v-col>
                            </v-row>
                            <v-row v-if="pesoErr">
                                <v-col class="error--text">
                                    Errore: Raggiunto peso massimo consentito
                                </v-col>
                            </v-row>
                            <v-row>
                                <v-col cols="5" />
                                <v-col cols="1">
                                    <v-tooltip bottom>
                                        <template v-slot:activator="{ on }">
                                            <v-btn
                                                v-on="on"
                                                small
                                                elevation="1"
                                                class="ma-2"
                                                @click="insertPack(item)"
                                            >
                                                <v-icon color="primary">
                                                    mdi-plus
                                                </v-icon>
                                            </v-btn>
                                        </template>
                                        <span>Inserisce Pacco</span>
                                    </v-tooltip>
                                </v-col>
                                <v-col cols="1">
                                    <v-tooltip bottom>
                                        <template v-slot:activator="{ on }">
                                            <v-btn
                                                v-on="on"
                                                small
                                                elevation="1"
                                                class="ma-2"
                                                @click="insertPacksAuto(item)"
                                            >
                                                <v-icon color="primary">
                                                    mdi-plus-box-multiple
                                                </v-icon>
                                            </v-btn>
                                        </template>
                                        <span
                                            >Inserisce Pacchi
                                            Automaticamente</span
                                        >
                                    </v-tooltip>
                                </v-col>
                                <v-col cols="5" />
                            </v-row>
                            <v-data-table
                                :headers="subHeaders"
                                :items="item.packs"
                                hide-default-footer
                                class="elevation-1"
                                :items-per-page="100"
                            >
                                <template v-slot:[`item.num`]="{ item }">
                                    <v-col v-if="item.num == null">
                                        Movimento gia eseguito
                                    </v-col>
                                    <v-col v-else>
                                        {{ item.num }}
                                    </v-col>
                                </template>
                                <template v-slot:[`item.quantita`]="{ item }">
                                    <v-col cols="6" dense>
                                        <v-text-field
                                            :disabled="item.path == 'Nessuno'"
                                            dense
                                            type="number"
                                            v-model="item.quantita"
                                            :readonly="
                                                item.id_magazzino_movimenti !=
                                                -1
                                            "
                                            @change="changeQnt(item)"
                                            @keyup="changeQnt(item)"
                                        >
                                        </v-text-field>
                                    </v-col>
                                </template>

                                <template v-slot:[`item.cod_lotto`]="{ item }">
                                    <v-col cols="9" dense>
                                        <v-text-field
                                            dense
                                            v-model="item.cod_lotto"
                                            :readonly="
                                                item.id_magazzino_movimenti !=
                                                -1
                                            "
                                        >
                                        </v-text-field>
                                    </v-col>
                                </template>
                                <template
                                    v-slot:[`item.qnt_massima`]="{ item }"
                                >
                                    {{ item.qnt_massima }}
                                </template>
                                <template v-slot:[`item.azioni`]="{ item }">
                                    <v-tooltip bottom>
                                        <template v-slot:activator="{ on }">
                                            <v-btn
                                                class="ma-1"
                                                v-on="on"
                                                small
                                                elevation="1"
                                                @click="duplicate(item)"
                                            >
                                                <v-icon color="primary">
                                                    mdi-content-copy
                                                </v-icon>
                                            </v-btn>
                                        </template>
                                        <span>Duplica</span>
                                    </v-tooltip>
                                    <v-tooltip bottom>
                                        <template v-slot:activator="{ on }">
                                            <v-btn
                                                :disabled="
                                                    item.id_magazzino_movimenti <
                                                    0
                                                "
                                                class="mx-1"
                                                v-on="on"
                                                small
                                                elevation="1"
                                                @click="previewReport(item)"
                                            >
                                                <v-icon color="primary">
                                                    mdi-printer
                                                </v-icon>
                                            </v-btn>
                                        </template>
                                        <span>Stampa Etichetta</span>
                                    </v-tooltip>
                                    <v-tooltip bottom>
                                        <template v-slot:activator="{ on }">
                                            <v-btn
                                                :disabled="
                                                    item.id_magazzino_movimenti !=
                                                        -1 ||
                                                    qntErr ||
                                                    pesoErr ||
                                                    item.path == 'Nessuno' ||
                                                    item.quantita == 0 ||
                                                    item.cod_lotto == '' ||
                                                    item.cod_lotto == null
                                                "
                                                class="mx-1"
                                                v-on="on"
                                                small
                                                elevation="1"
                                                @click="setMovimento([item])"
                                            >
                                                <v-icon color="success">
                                                    mdi-check
                                                </v-icon>
                                            </v-btn>
                                        </template>
                                        <span>Conferma Ubicazione</span>
                                    </v-tooltip>
                                </template>
                                <template v-slot:[`item.path`]="{ item }">
                                    <v-tooltip bottom>
                                        <template v-slot:activator="{ on }">
                                            <v-btn
                                                :disabled="
                                                    item.id_magazzino_movimenti !=
                                                    -1
                                                "
                                                v-on="on"
                                                small
                                                elevation="1"
                                                class="ma-1"
                                                @click="selectUbicazione(item)"
                                            >
                                                <v-icon color="primary">
                                                    mdi-pencil
                                                </v-icon>
                                            </v-btn>
                                        </template>
                                        <span>Modifica Ubicazione</span>
                                    </v-tooltip>
                                    {{ item.path }}
                                </template>

                                <template v-slot:[`item.articoli`]="{ item }">
                                    <v-tooltip bottom>
                                        <template v-slot:activator="{ on }">
                                            <v-btn
                                                v-if="
                                                    'articoliPresenti' in
                                                        item &&
                                                    item.articoliPresenti
                                                        .length > 0 &&
                                                    item.id_magazzino_movimenti ==
                                                        -1
                                                "
                                                v-on="on"
                                                small
                                                elevation="1"
                                                class="ma-1"
                                                @click="showPresenti(item)"
                                            >
                                                <v-icon color="primary">
                                                    mdi-eye
                                                </v-icon>
                                            </v-btn>
                                        </template>
                                        <span>Articoli Presenti</span>
                                    </v-tooltip>
                                </template>

                                <template v-slot:[`item.rimuovi`]="{ item }">
                                    <v-tooltip bottom>
                                        <template v-slot:activator="{ on }">
                                            <v-btn
                                                :disabled="
                                                    item.id_magazzino_movimenti !=
                                                    -1
                                                "
                                                v-on="on"
                                                small
                                                elevation="1"
                                                @click="remove(item)"
                                            >
                                                <v-icon class="error--text">
                                                    mdi-close
                                                </v-icon>
                                            </v-btn>
                                        </template>
                                        <span>Rimuovi Contenitore</span>
                                    </v-tooltip>
                                </template>
                            </v-data-table>
                        </td>
                    </template>
                </v-data-table>
            </v-card-text>
        </v-card>

        <v-dialog persistent v-model="showAggregaDialog" width="600">
            <v-card>
                <v-toolbar color="indigo" dense>
                    <v-toolbar-title class="white--text"
                        >Aggregazione</v-toolbar-title
                    >

                    <v-spacer></v-spacer>

                    <v-tooltip bottom>
                        <template v-slot:activator="{ on }">
                            <v-btn
                                class="mx-1"
                                v-on="on"
                                small
                                elevation="1"
                                @click="getUbicazioneAggregata()"
                            >
                                <v-icon color="primary"> mdi-warehouse</v-icon>
                            </v-btn>
                        </template>
                        <span>Seleziona Ubicazione</span>
                    </v-tooltip>

                    <v-tooltip bottom>
                        <template v-slot:activator="{ on }">
                            <v-btn
                                :disabled="
                                    ubicazioneAggregata.id_ubicazione == -1
                                "
                                class="mx-1"
                                v-on="on"
                                small
                                elevation="1"
                                @click="setMovimentoAggregato"
                            >
                                <v-icon color="success"> mdi-check</v-icon>
                            </v-btn>
                        </template>
                        <span>Conferma Ubicazione</span>
                    </v-tooltip>

                    <v-spacer></v-spacer>

                    <v-tooltip bottom>
                        <template v-slot:activator="{ on, attrs }">
                            <v-btn
                                @click="showAggregaDialog = false"
                                small
                                v-bind="attrs"
                                v-on="on"
                            >
                                <v-icon color="error">mdi-close</v-icon>
                            </v-btn>
                        </template>
                        <span>Chiudi</span>
                    </v-tooltip>
                </v-toolbar>
                <v-progress-linear
                    indeterminate
                    color="cyan"
                    v-if="loading"
                    id="progress"
                >
                </v-progress-linear>
                <v-card-text>
                    <v-col>
                        <v-row
                            align="center"
                            justify="center"
                            align-content="center"
                        >
                            <h3>
                                {{ "Ubicazione: " + ubicazioneAggregata.path }}
                            </h3>
                        </v-row>
                        <v-row>
                            <v-data-table
                                :items="listaAggrega"
                                :headers="aggregaHeaders"
                            >
                                <template v-slot:[`item.qnt_pac`]="{ item }">
                                    <v-col cols="6" dense>
                                        <v-text-field
                                            dense
                                            type="number"
                                            v-model="item.qnt_pac"
                                        >
                                        </v-text-field>
                                    </v-col>
                                </template>
                            </v-data-table>
                        </v-row>
                    </v-col>
                </v-card-text>
            </v-card>
        </v-dialog>

        <v-dialog persistent v-model="ubicazioneDialog" width="400">
            <v-card>
                <v-toolbar color="indigo" dense>
                    <v-toolbar-title class="white--text"
                        >Selezione Ubicazione</v-toolbar-title
                    >

                    <v-spacer></v-spacer>

                    <v-tooltip bottom>
                        <template v-slot:activator="{ on, attrs }">
                            <v-btn
                                @click="ubicazioneDialog = false"
                                small
                                v-bind="attrs"
                                v-on="on"
                            >
                                <v-icon color="error">mdi-close</v-icon>
                            </v-btn>
                        </template>
                        <span>Chiudi</span>
                    </v-tooltip>
                </v-toolbar>
                <v-progress-linear
                    indeterminate
                    color="cyan"
                    v-if="loading"
                    id="progress"
                >
                </v-progress-linear>

                <v-col>
                    <v-select
                        :items="magazzini"
                        @change="getStruttura"
                        item-text="des_magazzino"
                        v-model="selMagazzino"
                        return-object
                        label="magazzino"
                        dense
                        outlined
                    >
                    </v-select>
                    <v-card flat max-height="60vh" class="overflow-y-auto">
                        <v-treeview
                            :items="ubicazioneTree"
                            return-object
                            item-key="name"
                        >
                            <template v-slot:append="{ item }">
                                <v-tooltip bottom>
                                    <template v-slot:activator="{ on }">
                                        <v-btn
                                            v-on="on"
                                            v-if="
                                                item.children == null &&
                                                !item.disabled
                                            "
                                            class="mr-2"
                                            small
                                            elevation="1"
                                            @click="
                                                tempPack != null
                                                    ? selectItem(item)
                                                    : selectUbicazioneAggregata(
                                                          item
                                                      )
                                            "
                                        >
                                            <v-icon color="success">
                                                mdi-check
                                            </v-icon>
                                        </v-btn>
                                    </template>
                                    <span>Seleziona</span>
                                </v-tooltip>

                                <v-tooltip bottom>
                                    <template v-slot:activator="{ on }">
                                        <v-icon
                                            color="error"
                                            v-on="on"
                                            v-if="item.disabled"
                                        >
                                            mdi-cancel
                                        </v-icon>
                                    </template>
                                    <span
                                        >Articolo Proibito in Questa
                                        Posizione</span
                                    >
                                </v-tooltip>
                            </template>
                        </v-treeview>
                    </v-card>
                </v-col>
            </v-card>
        </v-dialog>

        <v-dialog v-model="confirmUbicazioneDialog" width="500">
            <v-card>
                <v-toolbar class="indigo white--text" dense>
                    <v-toolbar-title class="white--text">
                        Conferma Ubicazione
                    </v-toolbar-title>
                    <v-spacer></v-spacer>
                    <v-tooltip bottom>
                        <template v-slot:activator="{ on }">
                            <v-btn
                                v-on="on"
                                @click="confirmUbicazioneDialog = false"
                                small
                            >
                                <v-icon color="success"> mdi-check </v-icon>
                            </v-btn>
                        </template>
                        <span>Conferma</span>
                    </v-tooltip>
                    <v-spacer></v-spacer>
                    <v-tooltip bottom>
                        <template v-slot:activator="{ on }">
                            <v-btn
                                v-on="on"
                                @click="confirmUbicazioneDialog_no"
                                small
                            >
                                <v-icon class="error--text"> mdi-close </v-icon>
                            </v-btn>
                        </template>
                        <span>Annulla</span>
                    </v-tooltip>
                </v-toolbar>
                <v-card-text>
                    <v-col cols="12">
                        <h3>Ubicazione già occupata:</h3>
                        <v-data-table
                            dense
                            :headers="confirmUbicazioneHeaders"
                            :items="tempArticoli"
                        >
                        </v-data-table>
                        <h3>sicuro di voler procedere?</h3>
                    </v-col>
                </v-card-text>
            </v-card>
        </v-dialog>

        <v-dialog v-model="dialogPreview" width="800">
            <v-card>
                <v-toolbar class="indigo white--text" dense>
                    <v-toolbar-title class="white--text">
                        Stampa Etichetta</v-toolbar-title
                    >
                    <v-spacer></v-spacer>
                    <v-tooltip bottom>
                        <template v-slot:activator="{ on }">
                            <v-btn v-on="on" @click="confirmPrint()" small>
                                <v-icon color="primary"> mdi-printer </v-icon>
                            </v-btn>
                        </template>
                        <span>Stampa</span>
                    </v-tooltip>
                    <v-spacer></v-spacer>

                    <v-tooltip bottom v-if="multiPage">
                        <template v-slot:activator="{ on }">
                            <v-btn
                                v-on="on"
                                @click="cPage > 0 ? cPage-- : (cPage = cPage)"
                                small
                                class="mr-10"
                            >
                                <v-icon color="primary">
                                    mdi-arrow-left
                                </v-icon>
                            </v-btn>
                        </template>
                        <span>Pagina precedente</span>
                    </v-tooltip>

                    <v-tooltip bottom v-if="multiPage">
                        <template v-slot:activator="{ on }">
                            <v-btn
                                v-on="on"
                                @click="
                                    cPage < pdfs.length - 1
                                        ? cPage++
                                        : (cPage = cPage)
                                "
                                small
                            >
                                <v-icon color="primary">
                                    mdi-arrow-right
                                </v-icon>
                            </v-btn>
                        </template>
                        <span>Prossima pagina</span>
                    </v-tooltip>

                    <v-spacer></v-spacer>
                    <v-tooltip bottom>
                        <template v-slot:activator="{ on }">
                            <v-btn
                                v-on="on"
                                @click="dialogPreview = false"
                                small
                            >
                                <v-icon class="error--text"> mdi-close </v-icon>
                            </v-btn>
                        </template>
                        <span>Chiudi</span>
                    </v-tooltip>
                </v-toolbar>
                <v-progress-linear
                    indeterminate
                    color="cyan"
                    v-if="loading"
                    id="progress"
                >
                </v-progress-linear>
                <v-col cols="12">
                    <iframe
                        :src="multiPage ? pdfs[cPage] : iframeUrl"
                        frameborder="0"
                        style="height: 70vh !important; width: 750px !important"
                    >
                    </iframe>
                </v-col>
            </v-card>
        </v-dialog>

        <v-dialog v-model="dialogStampa" width="800">
            <v-card>
                <v-toolbar class="indigo white--text" dense>
                    <v-toolbar-title class="white--text">
                        Stampa Etichetta</v-toolbar-title
                    >
                    <v-spacer></v-spacer>
                    <v-tooltip bottom>
                        <template v-slot:activator="{ on }">
                            <v-btn
                                v-on="on"
                                @click="dialogStampa = false"
                                small
                            >
                                <v-icon class="error--text"> mdi-close </v-icon>
                            </v-btn>
                        </template>
                        <span>Chiudi</span>
                    </v-tooltip>
                </v-toolbar>
                <v-card max-height="80vh" class="overflow-y-auto">
                    <v-col
                        v-for="item in printItems"
                        :key="item.id_documento_dettaglio"
                    >
                        <v-sheet outlined color="black" class="rounded-0">
                            <v-card outlined class="rounded-0">
                                <barcode :value="item.cod_articolo"> </barcode>
                            </v-card>
                        </v-sheet>
                    </v-col>
                </v-card>
            </v-card>
        </v-dialog>

        <v-dialog v-model="dialogArticoli" width="800">
            <v-card>
                <v-toolbar class="indigo white--text" dense primary-title>
                    <v-toolbar-title>Articoli Presenti</v-toolbar-title>
                    <v-spacer></v-spacer>
                    <v-tooltip bottom>
                        <template v-slot:activator="{ on }">
                            <v-btn
                                v-on="on"
                                @click="dialogArticoli = false"
                                small
                            >
                                <v-icon class="error--text"> mdi-close </v-icon>
                            </v-btn>
                        </template>
                        <span>Chiudi</span>
                    </v-tooltip>
                </v-toolbar>
                <v-card-text>
                    <v-data-table
                        :headers="articoliHeaders"
                        :items="tempArticoli"
                    >
                    </v-data-table>
                </v-card-text>
            </v-card>
        </v-dialog>

        <SnackbarQV ref="SnackbarQV" />
    </div>
</template>

<script>
import SnackbarQV from "@/components/TOOLS/SnackbarQV.vue";
import VueBarcode from "vue-barcode";

export default {
    name: "DDTDettaglio",
    props: ["num_ddt", "id_ddt"],
    components: {
        barcode: VueBarcode,
        SnackbarQV,
    },
    data() {
        return {
            confirmUbicazioneDialog: false,
            aggregatoConfermato: false,
            showAggregaDialog: false,
            showOverlay: false,
            cPage: 0,
            multiPage: false,
            nextId: 1,
            dialogPreview: false,
            iframeUrl: null,
            dialogArticoli: false,
            pesoErr: false,
            dialogStampa: false,
            qntErr: false,
            ubicazioneDialog: false,
            filterVisible: false,
            loading: false,
            key: 0,
            tempPack: null,
            selMagazzino: null,
            ubicazioneAggregata: {},
            pdfs: [],
            listaAggrega: [],
            printIds: [],
            labelTypes: [],
            magazzini: [],
            expandedItems: [],
            listDDT: [],
            ubicazioneTree: [],
            filtroCod: "Tutti",
            filtroStato: "Tutti",
            codici: [],
            printItems: [],
            tempArticoli: [],
            stati: [
                "Tutti",
                "Nessun ubicazione confermato",
                "Ubicazioni parzialmente confermati",
                "Ubicazioni completatmente confermati",
            ],
            stateIcons: [
                {
                    color: "error",
                    icon: "mdi-cancel",
                    desc: "Nessun ubicazione confermato",
                },
                {
                    color: "yellow accent-4",
                    icon: "mdi-information",
                    desc: "Ubicazioni parzialmente confermati",
                },
                {
                    color: "success",
                    icon: "mdi-check",
                    desc: "Ubicazioni completatmente confermati",
                },
            ],
            aggregaHeaders: [
                {
                    text: "Codice Articolo",
                    value: "cod_articolo",
                },
                {
                    text: "Quantita Ricevuta",
                    value: "quantita",
                },
                {
                    text: "Quantita Pacco",
                    value: "qnt_pac",
                },
            ],
            headers: [
                {
                    text: "Aggrega",
                    value: "aggrega",
                },
                {
                    text: "Stampa",
                    value: "stampa",
                },
                {
                    text: "Cod. Articolo",
                    value: "cod_articolo",
                },
                {
                    text: "Des. Articolo",
                    value: "descrizione",
                },
                {
                    text: "Quantita ricevuta",
                    value: "quantita",
                },
                {
                    text: "Quantita magazzino",
                    value: "inMagazzino",
                },
                {
                    text: "Quantita pacchi",
                    value: "qntPack",
                },
                {
                    text: "Stato",
                    value: "stato",
                },
            ],
            subHeaders: [
                {
                    text: "Azioni",
                    value: "azioni",
                },
                {
                    text: "Ubicazione",
                    value: "path",
                },
                {
                    text: "",
                    value: "articoli",
                },
                {
                    text: "Quantita",
                    value: "quantita",
                },
                {
                    text: "Quantita Massima",
                    value: "qnt_massima",
                },
                {
                    text: "Seriale",
                    value: "seriale",
                },
                {
                    text: "Lotto",
                    value: "cod_lotto",
                },
                {
                    text: "Rimuovi",
                    value: "rimuovi",
                },
            ],
            confirmUbicazioneHeaders: [
                {
                    text: "Codice",
                    value: "cod_articolo",
                },
                {
                    text: "Quantita",
                    value: "quantita",
                },
            ],
            articoliHeaders: [
                {
                    text: "Codice",
                    value: "cod_articolo",
                },
                {
                    text: "Quantita",
                    value: "quantita",
                },
                {
                    text: "Peso",
                    value: "peso_netto",
                },
            ],
        };
    },
    mounted() {
        this.inizializza();
    },
    methods: {
        confirmUbicazioneDialog_no() {
            this.tempPack.articoliPresenti = [];
            this.tempPack.path = "Nessuno";
            this.tempPack.id_ubicazione = -1;
            this.tempPack.id_magazzino = -1;
            this.confirmUbicazioneDialog = false;
        },
        async getUbicazioneAggregata() {
            const request = {
                controller: "Magazzino",
                method: "POST",
                richiesta: {
                    action: "getassignubicazioni",
                    token: localStorage.user_token,
                    articoli: [
                        {
                            id_articolo: -1,
                            id_famiglia: -1,
                            id_sub_famiglia: -1,
                        },
                    ],
                },
            };
            await this.$store.dispatch("api", request).then((res) => {
                if (res.status === 200) {
                    if (res.data.result["-1"].length > 0) {
                        this.ubicazioneAggregata = res.data.result["-1"][0];
                        this.ubicazioneAggregata.id_ubicazione =
                            this.ubicazioneAggregata.id_magazzino_ubicazione;
                    } else {
                        this.$refs.SnackbarQV.print(
                            "error",
                            "Nessun ubicazione disponibile"
                        );
                    }
                }
            });
        },
        async setMovimentoAggregato() {
            var movimentiAggregati = [];
            this.listaAggrega.forEach((e) => {
                movimentiAggregati.push({
                    id_controllo: 0,
                    id_magazzino_movimenti: -1,
                    quantita: e.qnt_pac,
                    id_ubicazione: this.ubicazioneAggregata.id_ubicazione,
                    id_documento_dettaglio: e.id_documento_dettaglio,
                    id_magazzino: this.ubicazioneAggregata.id_magazzino,
                    id_articolo: e.id_articolo,
                    cod_articolo: e.cod_articolo,
                    id_documento: e.id_documento,
                    numero_seriale: -2,
                });
            });
            this.showAggregaDialog = false;
            await this.setMovimento(movimentiAggregati);
            this.inizializza();
        },
        printAggregato() {
            console.log(this.ubicazioneAggregata);
        },
        selectUbicazioneAggregata(item) {
            this.ubicazioneAggregata.path = item.path;
            this.ubicazioneAggregata.id_ubicazione =
                item.id_magazzino_ubicazione;
            this.ubicazioneAggregata.id_magazzino = item.id_magazzino;
            this.ubicazioneDialog = false;
        },
        aggregate() {
            this.ubicazioneAggregata = {
                path: "Nessuno",
                id_ubicazione: -1,
                id_magazzino: -1,
            };
            this.listaAggrega = [];
            this.listDDT.forEach((e) => {
                if (e.aggregaFlag) {
                    this.listaAggrega.push(Object.assign({ qnt_pac: 0 }, e));
                }
            });
            if (this.listaAggrega.length > 1) {
                this.showAggregaDialog = true;
            } else {
                this.$refs.SnackbarQV.print(
                    "error",
                    "Seleziona almeno due righe da aggregare"
                );
            }
        },
        packTot(item) {
            var t = 0;
            item.packs.forEach((e) => {
                t += parseInt(e.quantita);
            });
            return t;
        },
        async confirmPrint() {
            try {
                this.loading = true;

                const request = {
                    controller: "Global",
                    method: "POST",
                    richiesta: {
                        action: "getdispositiviutente",
                        token: localStorage.user_token,
                    },
                };

                var pName = "";
                var labelType = 0;

                await this.$store.dispatch("api", request).then((res) => {
                    console.log(res);
                    pName = res.data.result.dispositivi[0].nome_dispositivo;
                });

                var tempPrintId = 0;
                if (this.multiPage) {
                    tempPrintId = this.printIds[this.cPage];
                    labelType = this.labelTypes[this.cPage];
                } else {
                    tempPrintId = this.printIds[0];
                    labelType = this.labelTypes[0];
                }

                var request2 = {};

                if (labelType == 0) {
                    request2 = {
                        controller: "report",
                        method: "POST",
                        richiesta: {
                            action: "getreportpdf",
                            token: localStorage.user_token,
                            cod_report: "rptArticoloDdt",
                            printer_name: pName,
                            parametri: [
                                {
                                    parametro: "@id_magazzino_movimenti",
                                    valore: tempPrintId,
                                },
                            ],
                        },
                    };
                } else {
                    request2 = {
                        controller: "report",
                        method: "POST",
                        richiesta: {
                            action: "getreportpdf",
                            token: localStorage.user_token,
                            cod_report: "ddt_aggregato",
                            printer_name: pName,
                            parametri: [
                                {
                                    parametro: "@seriale",
                                    valore: tempPrintId,
                                },
                            ],
                        },
                    };
                }

                await this.$store.dispatch("api", request2).then((res) => {
                    if (
                        "tipo_messaggio" in res.data &&
                        "query_messaggio" in res.data &&
                        res.data.tipo_messaggio == 1
                    ) {
                        this.$refs.SnackbarQV.print(
                            "orange",
                            res.data.query_messaggio
                        );
                    } else {
                        this.$refs.SnackbarQV.print(
                            "success",
                            "Etichetta stampata"
                        );
                    }
                    this.loading = false;
                });
            } catch (err) {
                if (
                    "tipo_messaggio" in err.response.data &&
                    "query_messaggio" in err.response.data &&
                    err.response.data.tipo_messaggio == 2
                ) {
                    this.$refs.SnackbarQV.print(
                        "error",
                        err.response.data.query_messaggio
                    );
                } else {
                    this.$refs.SnackbarQV.print("error", err.toString());
                }
            }
        },
        showPresenti(item) {
            this.tempArticoli = item.articoliPresenti;
            this.dialogArticoli = true;
        },
        async inizializza() {
            this.loading = true;

            const request = {
                controller: "Magazzino",
                method: "POST",
                richiesta: {
                    action: "getdocumento",
                    token: localStorage.user_token,
                    id_documento: this.id_ddt,
                    cod_documento: "DDT",
                },
            };

            await this.$store
                .dispatch("api", request)
                .then((res) => {
                    if (res.status === 200) {
                        this.listDDT = Array.from(
                            res.data.documento[0].dettaglio
                        );
                        this.listDDT.forEach((e) => {
                            e.aggregaFlag = false;
                            e.inMagazzino = 0;
                            e.nextpack = 1;
                            e.packs = [];
                            this.codici.push(e.cod_articolo);
                        });
                        this.filtered = this.listDDT;
                    } else {
                        this.$refs.SnackbarQV.print(
                            "error",
                            "Errore di comunicazione col server, impossibile caricar ei dati."
                        );
                    }
                    this.loading = false;
                    console.log(this.listDDT);
                })
                .catch((err) => {
                    this.loading = false;
                    if (err) {
                        this.$refs.SnackbarQV.print(
                            "error",
                            "Errore di comunicazione col server, impossibile caricare i dati."
                        );
                    }
                });

            this.codici.sort((a, b) => (a < b ? -1 : a > b ? 1 : 0));
            this.codici.unshift("Tutti");

            const request2 = {
                controller: "Magazzino",
                method: "POST",
                richiesta: {
                    action: "getdocumentomovimenti",
                    token: localStorage.user_token,
                    id_documento: this.id_ddt,
                    cod_documento: "DDT",
                },
            };

            await this.$store
                .dispatch("api", request2)
                .then((res) => {
                    if (res.status === 200) {
                        for (
                            let i = 0;
                            i < res.data.result.movimenti.length;
                            i++
                        ) {
                            const e = res.data.result.movimenti[i];
                            console.log(e);
                            if (
                                parseInt(e.numero_seriale.substring(2)) >=
                                this.nextId
                            ) {
                                this.nextId =
                                    parseInt(e.numero_seriale.substring(2)) + 1;
                            }
                            for (let i2 = 0; i2 < this.listDDT.length; i2++) {
                                const e2 = this.listDDT[i2];
                                if (
                                    e2.id_documento_dettaglio ==
                                    e.id_documento_dettaglio
                                ) {
                                    e2.packs.push(Object.assign({}, e));
                                    e2.inMagazzino += e.quantita;
                                }
                            }
                            this.key += 1;
                        }
                    } else {
                        this.$refs.SnackbarQV.print(
                            "error",
                            "Errore di comunicazione col server, impossibile caricar ei dati."
                        );
                    }
                    this.loading = false;
                })
                .catch((err) => {
                    this.loading = false;
                    if (err) {
                        this.$refs.SnackbarQV.print(
                            "error",
                            "Errore di comunicazione col server, impossibile caricare i dati."
                        );
                    }
                });
            console.log(this.listDDT);
        },
        getLabelType(item) {
            var withSerial = 0;
            this.listDDT.forEach((e) => {
                e.packs.forEach((e2) => {
                    if (e2.seriale == item.seriale) {
                        withSerial++;
                    }
                });
            });
            console.log(withSerial);
            if (withSerial > 1) {
                return 1;
            } else {
                return 0;
            }
        },
        printArticle(item) {
            this.printItems = [];
            this.printItems.push(Object.assign({}, item));
            this.dialogStampa = true;
        },
        async printRow(item) {
            this.loading = true;
            this.pdfs = [];
            this.printIds = [];
            this.labelTypes = [];
            this.cPage = 0;
            for (var i2 = 0; i2 < item.packs.length; i2++) {
                var p = item.packs[i2];
                var labelType = this.getLabelType(p);
                this.labelTypes.push(labelType);
                if (p.id_magazzino_movimenti > 0) {
                    var request = {};

                    if (labelType == 0) {
                        request = {
                            controller: "report",
                            method: "POST",
                            richiesta: {
                                action: "getreportpdf",
                                token: localStorage.user_token,
                                cod_report: "rptArticoloDdt",
                                parametri: [
                                    {
                                        parametro: "@id_magazzino_movimenti",
                                        valore: p.id_magazzino_movimenti,
                                    },
                                ],
                            },
                        };
                    } else {
                        request = {
                            controller: "report",
                            method: "POST",
                            richiesta: {
                                action: "getreportpdf",
                                token: localStorage.user_token,
                                cod_report: "ddt_aggregato",
                                parametri: [
                                    {
                                        parametro: "@seriale",
                                        valore: p.seriale,
                                    },
                                ],
                            },
                        };
                    }

                    await this.$store
                        .dispatch("api", request)
                        .then((res) => {
                            if (res.status === 200) {
                                if (
                                    "tipo_messaggio" in res.data &&
                                    "query_messaggio" in res.data &&
                                    res.data.tipo_messaggio == 1
                                ) {
                                    this.$refs.SnackbarQV.print(
                                        "orange",
                                        res.data.query_messaggio
                                    );
                                }
                                const response = res.data.result;
                                const byteCharacters = atob(response);
                                const byteNumbers = new Array(
                                    byteCharacters.length
                                );
                                for (
                                    let i = 0;
                                    i < byteCharacters.length;
                                    i++
                                ) {
                                    byteNumbers[i] =
                                        byteCharacters.charCodeAt(i);
                                }
                                const byteArray = new Uint8Array(byteNumbers);
                                const blob = new Blob([byteArray], {
                                    type: "application/pdf",
                                });
                                const blobUrl = URL.createObjectURL(blob);
                                this.pdfs.push(blobUrl);
                                if (labelType == 0) {
                                    this.printIds.push(
                                        p.id_magazzino_movimenti
                                    );
                                } else {
                                    this.printIds.push(
                                        parseInt(p.id_magazzino_movimenti)
                                    );
                                }
                            } else {
                                this.$refs.SnackbarQV.print(
                                    "error",
                                    "Impossibile generare etichetta"
                                );
                            }
                        })
                        .catch((err) => {
                            if (
                                "tipo_messaggio" in err.response.data &&
                                "query_messaggio" in err.response.data &&
                                err.response.data.tipo_messaggio == 2
                            ) {
                                this.$refs.SnackbarQV.print(
                                    "error",
                                    err.response.data.query_messaggio
                                );
                            } else {
                                this.$refs.SnackbarQV.print(
                                    "error",
                                    err.toString()
                                );
                            }
                        });
                }
            }
            this.loading = false;
            this.multiPage = true;
            this.dialogPreview = true;
        },
        async printAll() {
            this.loading = true;
            this.pdfs = [];
            this.printIds = [];
            this.labelTypes = [];
            this.cPage = 0;
            for (var i = 0; i < this.listDDT.length; i++) {
                var e = this.listDDT[i];
                for (var i2 = 0; i2 < e.packs.length; i2++) {
                    var p = e.packs[i2];
                    var labelType = this.getLabelType(p);
                    this.labelTypes.push(labelType);
                    if (p.id_magazzino_movimenti > 0) {
                        var request = {};

                        if (labelType == 0) {
                            request = {
                                controller: "report",
                                method: "POST",
                                richiesta: {
                                    action: "getreportpdf",
                                    token: localStorage.user_token,
                                    cod_report: "rptArticoloDdt",
                                    parametri: [
                                        {
                                            parametro:
                                                "@id_magazzino_movimenti",
                                            valore: p.id_magazzino_movimenti,
                                        },
                                    ],
                                },
                            };
                        } else {
                            request = {
                                controller: "report",
                                method: "POST",
                                richiesta: {
                                    action: "getreportpdf",
                                    token: localStorage.user_token,
                                    cod_report: "ddt_aggregato",
                                    parametri: [
                                        {
                                            parametro: "@seriale",
                                            valore: p.seriale,
                                        },
                                    ],
                                },
                            };
                        }

                        await this.$store
                            .dispatch("api", request)
                            .then((res) => {
                                if (res.status === 200) {
                                    if (
                                        "tipo_messaggio" in res.data &&
                                        "query_messaggio" in res.data &&
                                        res.data.tipo_messaggio == 1
                                    ) {
                                        this.$refs.SnackbarQV.print(
                                            "orange",
                                            res.data.query_messaggio
                                        );
                                    }
                                    const response = res.data.result;
                                    const byteCharacters = atob(response);
                                    const byteNumbers = new Array(
                                        byteCharacters.length
                                    );
                                    for (
                                        let i = 0;
                                        i < byteCharacters.length;
                                        i++
                                    ) {
                                        byteNumbers[i] =
                                            byteCharacters.charCodeAt(i);
                                    }
                                    const byteArray = new Uint8Array(
                                        byteNumbers
                                    );
                                    const blob = new Blob([byteArray], {
                                        type: "application/pdf",
                                    });
                                    const blobUrl = URL.createObjectURL(blob);
                                    this.pdfs.push(blobUrl);
                                    if (labelType == 0) {
                                        this.printIds.push(
                                            p.id_magazzino_movimenti
                                        );
                                    } else {
                                        this.printIds.push(
                                            parseInt(p.id_magazzino_movimenti)
                                        );
                                    }
                                } else {
                                    this.$refs.SnackbarQV.print(
                                        "error",
                                        "Impossibile generare etichetta"
                                    );
                                }
                            })
                            .catch((err) => {
                                if (
                                    "tipo_messaggio" in err.response.data &&
                                    "query_messaggio" in err.response.data &&
                                    err.response.data.tipo_messaggio == 2
                                ) {
                                    this.$refs.SnackbarQV.print(
                                        "error",
                                        err.response.data.query_messaggio
                                    );
                                } else {
                                    this.$refs.SnackbarQV.print(
                                        "error",
                                        err.toString()
                                    );
                                }
                            });
                    }
                }
            }
            this.loading = false;
            this.multiPage = true;
            this.dialogPreview = true;
        },
        previewReport(item) {
            var labelType = this.getLabelType(item);

            var request = {};

            if (labelType == 1) {
                this.printIds = [parseInt(item.seriale)];
                this.labelTypes = [1];
                request = {
                    controller: "report",
                    method: "POST",
                    richiesta: {
                        action: "getreportpdf",
                        token: localStorage.user_token,
                        cod_report: "ddt_aggregato",
                        parametri: [
                            {
                                parametro: "@seriale",
                                valore: item.seriale,
                            },
                        ],
                    },
                };
            } else {
                this.printIds = [item.id_magazzino_movimenti];
                this.labelTypes = [0];
                request = {
                    controller: "report",
                    method: "POST",
                    richiesta: {
                        action: "getreportpdf",
                        token: localStorage.user_token,
                        cod_report: "rptArticoloDdt",
                        parametri: [
                            {
                                parametro: "@id_magazzino_movimenti",
                                valore: item.id_magazzino_movimenti,
                            },
                        ],
                    },
                };
            }

            this.loading = true;
            this.multiPage = false;
            console.log(item.id_magazzino_movimenti);
            /*var tempItem = {};
      this.listDDT.forEach((e) => {
        if (e.id_documento_dettaglio == item.id_documento_dettaglio) {
          tempItem = e;
        }
      });*/
            this.$store
                .dispatch("api", request)
                .then((res) => {
                    if (res.status === 200) {
                        if (
                            "tipo_messaggio" in res.data &&
                            "query_messaggio" in res.data &&
                            res.data.tipo_messaggio == 1
                        ) {
                            this.$refs.SnackbarQV.print(
                                "orange",
                                res.data.query_messaggio
                            );
                        }
                        const response = res.data.result;
                        const byteCharacters = atob(response);
                        const byteNumbers = new Array(byteCharacters.length);
                        for (let i = 0; i < byteCharacters.length; i++) {
                            byteNumbers[i] = byteCharacters.charCodeAt(i);
                        }
                        const byteArray = new Uint8Array(byteNumbers);
                        const blob = new Blob([byteArray], {
                            type: "application/pdf",
                        });
                        const blobUrl = URL.createObjectURL(blob);
                        this.iframeUrl = blobUrl;
                        this.loading = false;
                        this.dialogPreview = true;
                    } else {
                        this.$refs.SnackbarQV.print(
                            "error",
                            "Impossibile generare etichetta"
                        );
                    }
                    this.loading = false;
                })
                .catch((err) => {
                    this.loading = false;
                    if (
                        "tipo_messaggio" in err.response.data &&
                        "query_messaggio" in err.response.data &&
                        err.response.data.tipo_messaggio == 2
                    ) {
                        this.$refs.SnackbarQV.print(
                            "error",
                            err.response.data.query_messaggio
                        );
                    } else {
                        this.$refs.SnackbarQV.print("error", err.toString());
                    }
                });
        },
        printContainer(item) {
            console.log(item);
        },
        async updateStato() {
            var stato = 2;
            this.listDDT.forEach((e) => {
                console.log(e);
                e.inMagazzino = 0;
                e.packs.forEach((p) => {
                    console.log(p);
                    if (p.id_magazzino_movimenti != -1) {
                        e.inMagazzino += parseInt(p.quantita);
                    }
                });
                if (e.inMagazzino == 0 && stato != 1) {
                    stato = 0;
                } else if (e.inMagazzino < e.quantita) {
                    stato = 1;
                }
                console.log(e.inMagazzino);
            });

            const request = {
                controller: "Magazzino",
                method: "PUT",
                richiesta: {
                    action: "setstatodocumento",
                    token: localStorage.user_token,
                    id_documento: this.id_ddt,
                    stato_doc: stato,
                },
            };
            await this.$store
                .dispatch("api", request)
                .then((res) => {
                    if (res.status === 200) {
                        this.$refs.SnackbarQV.print(
                            "success",
                            "Movimento Salvato"
                        );
                    } else {
                        this.$refs.SnackbarQV.print(
                            "error",
                            "Movimento non Salvato"
                        );
                    }
                    this.loading = false;
                })
                .catch((err) => {
                    this.loading = false;
                    if (err) {
                        this.$refs.SnackbarQV.print(
                            "error",
                            "Movimento non Salvato"
                        );
                    }
                });
        },
        changeFilters() {
            this.filtered = this.listDDT.filter(
                (item) =>
                    (this.filtroCod == null ||
                        item.cod_articolo == this.filtroCod ||
                        this.filtroCod == "Tutti") &&
                    (this.filtroStato == null ||
                        this.filtroStato == "Tutti" ||
                        (item.inMagazzino < item.quantita &&
                            item.inMagazzino != 0 &&
                            this.filtroStato.includes("parzial")) ||
                        (item.inMagazzino == item.quantita &&
                            this.filtroStato.includes("complet")) ||
                        (item.inMagazzino == 0 &&
                            this.filtroStato.includes("Nessun")))
            );
        },
        insertPack(item) {
            console.log(this.expandedItems);
            item.packs.push({
                id_controllo: 0,
                peso_netto: item.peso_netto,
                id_magazzino_movimenti: -1,
                num: item.nextpack,
                quantita: 0,
                path: "Nessuno",
                id_ubicazione: -1,
                id_documento_dettaglio: item.id_documento_dettaglio,
                id_magazzino: -1,
                id_articolo: item.id_articolo,
                cod_articolo: item.cod_articolo,
                des_articolo: item.des_articolo,
                id_documento: item.id_documento,
                id_famiglia: item.id_famiglia,
                id_sotto_famiglia: item.id_sub_famiglia,
                numero_seriale: -1,
                qnt_massima: 0,
            });
            item.nextpack += 1;
            this.key += 1;
            this.expandedItems.push(item);
        },
        remove(item) {
            var ddtIndex = 0;
            var packIndex = 0;
            for (let i = 0; i < this.listDDT.length; i++) {
                const e = this.listDDT[i];
                if (e.id_documento_dettaglio == item.id_documento_dettaglio) {
                    ddtIndex = i;
                    for (let i2 = 0; i2 < e.packs.length; i2++) {
                        const e2 = e.packs[i2];
                        if (e2.num == item.num) {
                            packIndex = i2;
                            break;
                        }
                    }
                }
            }
            this.listDDT[ddtIndex].packs.splice(packIndex, 1);
            this.key += 1;
            this.expandedItems.push(this.listDDT[ddtIndex]);
            this.changeQnt({
                id_documento_dettaglio:
                    this.listDDT[ddtIndex].id_documento_dettaglio,
            });
        },
        setAllMovimenti() {
            var movimenti = [];
            this.listDDT.forEach((e) => {
                e.packs.forEach((p) => {
                    if (p.id_magazzino_movimenti == -1) {
                        movimenti.push(p);
                    }
                });
            });
            this.setMovimento(movimenti);
        },
        async setMovimento(item) {
            this.loading = true;
            const request = {
                controller: "Magazzino",
                method: "PUT",
                richiesta: {
                    action: "setmovimentimagazzino",
                    token: localStorage.user_token,
                    movimento: item,
                },
            };
            await this.$store
                .dispatch("api", request)
                .then(async (res) => {
                    if (res.status === 200) {
                        for (var i = 0; i < item.length; i++) {
                            item[i].id_magazzino_movimenti =
                                res.data.Table1[i].id_magazzino_movimenti;
                        }
                        await this.updateStato();
                    } else {
                        this.$refs.SnackbarQV.print(
                            "error",
                            "Movimento non Salvato"
                        );
                        this.loading = false;
                    }
                })
                .catch((err) => {
                    this.loading = false;
                    if (err) {
                        this.$refs.SnackbarQV.print(
                            "error",
                            "Movimento non Salvato"
                        );
                    }
                });
        },
        duplicate(item) {
            for (let i = 0; i < this.listDDT.length; i++) {
                const e = this.listDDT[i];
                if (e.id_documento_dettaglio == item.id_documento_dettaglio) {
                    var tempPack = Object.assign({}, item);
                    tempPack.id_magazzino_movimenti = -1;
                    tempPack.num = e.nextpack;
                    e.nextpack += 1;
                    e.packs.push(tempPack);
                    this.key += 1;
                    this.expandedItems.push(e);
                    break;
                }
            }
            this.changeQnt(item);
        },
        print(item) {
            console.log(item);
        },
        confermaUbicazione(item) {
            console.log(item);
        },
        async insertPacksAuto(item) {
            console.log(item);
            this.loading = true;
            this.showOverlay = true;
            var ubicazioni = [];
            var listDdtTemp = [item];

            if (listDdtTemp.length > 0) {
                const request = {
                    controller: "Magazzino",
                    method: "POST",
                    richiesta: {
                        action: "getassignubicazioni",
                        token: localStorage.user_token,
                        articoli: listDdtTemp,
                    },
                };
                await this.$store.dispatch("api", request).then((res) => {
                    if (res.status === 200) {
                        var qntRemain = item.quantita - this.packTot(item);
                        var iu = 0;
                        while (qntRemain > 0) {
                            this.insertPack(item);
                            item.packs[item.packs.length - 1].qnt_massima =
                                res.data.result[item.id_articolo.toString()][
                                    iu
                                ].qnt_massima;
                            item.packs[item.packs.length - 1].id_ubicazione =
                                res.data.result[item.id_articolo.toString()][
                                    iu
                                ].id_magazzino_ubicazione;
                            item.packs[item.packs.length - 1].id_magazzino =
                                res.data.result[item.id_articolo.toString()][
                                    iu
                                ].id_magazzino;
                            item.packs[item.packs.length - 1].path =
                                res.data.result[item.id_articolo.toString()][
                                    iu
                                ].path;
                            item.packs[
                                item.packs.length - 1
                            ].ubicazione_max_peso =
                                res.data.result[item.id_articolo.toString()][
                                    iu
                                ].peso_massimo;
                            ubicazioni.push({
                                id_ubicazione:
                                    res.data.result[
                                        item.id_articolo.toString()
                                    ][iu].id_magazzino_ubicazione,
                            });
                            if (
                                res.data.result[item.id_articolo.toString()][iu]
                                    .qnt_massima != null &&
                                res.data.result[item.id_articolo.toString()][iu]
                                    .qnt_massima != 0 &&
                                qntRemain >
                                    res.data.result[
                                        item.id_articolo.toString()
                                    ][iu].qnt_massima
                            ) {
                                item.packs[item.packs.length - 1].quantita =
                                    res.data.result[
                                        item.id_articolo.toString()
                                    ][iu].qnt_massima;
                                qntRemain -=
                                    res.data.result[
                                        item.id_articolo.toString()
                                    ][iu].qnt_massima;
                            } else {
                                item.packs[item.packs.length - 1].quantita =
                                    qntRemain;
                                qntRemain = 0;
                            }
                            iu += 1;
                        }
                    }
                });

                let request2 = {
                    controller: "Magazzino",
                    method: "POST",
                    richiesta: {
                        action: "getubicazionimovimenti",
                        ubicazioni: ubicazioni,
                        token: localStorage.user_token,
                    },
                };
                this.$store.dispatch("api", request2).then((res) => {
                    var peso = 0;
                    this.listDDT.forEach((e) => {
                        e.packs.forEach((e2) => {
                            console.log(res.data.result);
                            console.log(e2.id_ubicazione);
                            if (
                                e2.id_ubicazione != -1 &&
                                e2.id_magazzino_movimenti == -1
                            ) {
                                e2.articoliPresenti =
                                    res.data.result[
                                        e2.id_ubicazione.toString()
                                    ];
                                res.data.result[
                                    e2.id_ubicazione.toString()
                                ].forEach((e3) => {
                                    peso += e3.peso_netto * e3.quantita;
                                });
                                e2.ubicazione_att_peso = peso;
                                peso = 0;
                            }
                        });
                    });
                    console.log(this.listDDT);
                    this.key++;
                    this.loading = false;
                    this.showOverlay = false;
                });
            }
            this.loading = false;
            this.showOverlay = false;
        },
        async assignUbicazioni() {
            this.loading = true;
            this.showOverlay = true;
            var ubicazioni = [];
            var listDdtTemp = [];
            this.listDDT.forEach((e) => {
                if (e.packs.length > 0) {
                    listDdtTemp.push(e);
                }
            });

            if (listDdtTemp.length > 0) {
                const request = {
                    controller: "Magazzino",
                    method: "POST",
                    richiesta: {
                        action: "getassignubicazioni",
                        token: localStorage.user_token,
                        articoli: listDdtTemp,
                    },
                };
                await this.$store
                    .dispatch("api", request)
                    .then((res) => {
                        if (res.status === 200) {
                            this.listDDT.forEach((e) => {
                                var qntRemain = e.quantita - e.inMagazzino;
                                var iu = 0;
                                e.packs.forEach((e2) => {
                                    if (e2.id_magazzino_movimenti == -1) {
                                        e2.qnt_massima =
                                            res.data.result[
                                                e.id_articolo.toString()
                                            ][iu].qnt_massima;
                                        e2.id_ubicazione =
                                            res.data.result[
                                                e.id_articolo.toString()
                                            ][iu].id_magazzino_ubicazione;
                                        e2.id_magazzino =
                                            res.data.result[
                                                e.id_articolo.toString()
                                            ][iu].id_magazzino;
                                        e2.path =
                                            res.data.result[
                                                e.id_articolo.toString()
                                            ][iu].path;
                                        e2.ubicazione_max_peso =
                                            res.data.result[
                                                e.id_articolo.toString()
                                            ][iu].peso_massimo;
                                        ubicazioni.push({
                                            id_ubicazione:
                                                res.data.result[
                                                    e.id_articolo.toString()
                                                ][iu].id_magazzino_ubicazione,
                                        });

                                        if (
                                            res.data.result[
                                                e.id_articolo.toString()
                                            ][iu].qnt_massima != null &&
                                            res.data.result[
                                                e.id_articolo.toString()
                                            ][iu].qnt_massima != 0 &&
                                            qntRemain >
                                                res.data.result[
                                                    e.id_articolo.toString()
                                                ][iu].qnt_massima
                                        ) {
                                            e2.quantita =
                                                res.data.result[
                                                    e.id_articolo.toString()
                                                ][iu].qnt_massima;
                                            qntRemain -=
                                                res.data.result[
                                                    e.id_articolo.toString()
                                                ][iu].qnt_massima;
                                            iu += 1;
                                        } else {
                                            e2.quantita = qntRemain;
                                            qntRemain = 0;
                                        }
                                    }
                                });
                            });
                        } else {
                            this.$refs.SnackbarQV.print(
                                "error",
                                "Errore di comunicazione col server, impossibile caricar ei dati."
                            );
                        }
                        this.loading = false;
                        this.showOverlay = false;
                    })
                    .catch((err) => {
                        this.loading = false;
                        this.showOverlay = false;
                        if (err) {
                            this.$refs.SnackbarQV.print(
                                "error",
                                "Errore di comunicazione col server, impossibile caricare i dati."
                            );
                        }
                    });

                let request2 = {
                    controller: "Magazzino",
                    method: "POST",
                    richiesta: {
                        action: "getubicazionimovimenti",
                        ubicazioni: ubicazioni,
                        token: localStorage.user_token,
                    },
                };
                this.$store.dispatch("api", request2).then((res) => {
                    var peso = 0;
                    this.listDDT.forEach((e) => {
                        e.packs.forEach((e2) => {
                            console.log(res.data.result);
                            console.log(e2.id_ubicazione);
                            if (
                                e2.id_ubicazione != -1 &&
                                e2.id_magazzino_movimenti == -1
                            ) {
                                e2.articoliPresenti =
                                    res.data.result[
                                        e2.id_ubicazione.toString()
                                    ];
                                res.data.result[
                                    e2.id_ubicazione.toString()
                                ].forEach((e3) => {
                                    peso += e3.peso_netto * e3.quantita;
                                });
                                e2.ubicazione_att_peso = peso;
                                peso = 0;
                            }
                        });
                    });
                    console.log(this.listDDT);
                    this.key++;
                    this.loading = false;
                    this.showOverlay = false;
                });
            }
            this.loading = false;
            this.showOverlay = false;
        },
        showFilter() {
            this.filterVisible = !this.filterVisible;
        },
        printItem(item) {
            console.log(item);
        },
        selectItem(item) {
            this.tempPack.ubicazione_max_peso = item.peso_massimo;
            this.loading = true;
            var ubicazioni = [{ id_ubicazione: item.id_magazzino_ubicazione }];
            var peso = 0;
            let request = {
                controller: "Magazzino",
                method: "POST",
                richiesta: {
                    action: "getubicazionimovimenti",
                    ubicazioni: ubicazioni,
                    token: localStorage.user_token,
                },
            };
            this.$store.dispatch("api", request).then((res) => {
                if (
                    res.data.result[item.id_magazzino_ubicazione.toString()]
                        .length > 0
                ) {
                    this.tempArticoli = Array.from(
                        res.data.result[item.id_magazzino_ubicazione.toString()]
                    );
                    this.confirmUbicazioneDialog = true;
                }
                res.data.result[
                    item.id_magazzino_ubicazione.toString()
                ].forEach((e) => {
                    peso += e.peso_netto * e.quantita;
                });
                this.tempPack.ubicazione_att_peso = peso;
                this.tempPack.articoliPresenti =
                    res.data.result[item.id_magazzino_ubicazione.toString()];
                this.key++;
                this.loading = false;
            });
            this.tempPack.path = item.path;
            this.tempPack.id_ubicazione = item.id_magazzino_ubicazione;
            this.tempPack.id_magazzino = item.id_magazzino;
            this.ubicazioneDialog = false;
            console.log(this.listDDT);
        },
        selectUbicazione(item) {
            this.tempPack = item;
            this.loading = true;
            let request = {
                controller: "Magazzino",
                method: "POST",
                richiesta: {
                    action: "getmagazzini",
                    token: localStorage.user_token,
                },
            };
            this.$store.dispatch("api", request).then((res) => {
                this.magazzini = Array.from(res.data);
                this.loading = false;
                this.ubicazioneDialog = true;
            });
        },
        fixtree(arg, disable) {
            try {
                arg.forEach((e) => {
                    e.disabled = disable;
                    if (this.tempPack != null) {
                        if (
                            e.famiglie_proibite != null &&
                            (e.famiglie_proibite.includes(
                                this.tempPack.id_famiglia
                            ) ||
                                e.famiglie_proibite.includes(
                                    this.tempPack.id_sotto_famiglia
                                ))
                        ) {
                            e.disabled = true;
                        }
                        if (
                            e.articoli_proibiti != null &&
                            e.articoli_proibiti.includes(
                                this.tempPack.id_articolo
                            )
                        ) {
                            e.disabled = true;
                        }
                    }

                    e.children = null;
                    Object.keys(e).forEach((k) => {
                        if (k.includes("dettaglio") && !k.includes("_")) {
                            e.children = e[k];
                        }
                    });
                    e.name = e.des_dettaglio;
                    this.fixtree(e.children, e.disabled);
                });
            } catch (error) {
                console.log(error);
                return;
            }
        },
        getStruttura(arg) {
            this.loading = true;
            var request = {
                controller: "Magazzino",
                method: "POST",
                richiesta: {
                    action: "getmagazzinoubicazione",
                    token: localStorage.user_token,
                    id_utente: localStorage.id,
                    id_magazzino: arg.id_magazzino,
                },
            };

            this.$store.dispatch("api", request).then(async (res) => {
                if (res.status == 200) {
                    this.ubicazioneTree = Array.from(res.data.dettaglio0);
                    this.fixtree(this.ubicazioneTree, false);
                    console.log(this.ubicazioneTree);
                    this.$forceUpdate();
                    this.loading = false;
                }
            });
        },
        changeQnt(item) {
            var peso_netto = 0;
            this.listDDT.forEach((e) => {
                if (e.id_documento_dettaglio == item.id_documento_dettaglio) {
                    var sum = 0;
                    peso_netto = e.peso_netto;
                    this.qntErr = false;
                    e.packs.forEach((e2) => {
                        console.log(e2);
                        sum += parseInt(e2.quantita);
                    });
                    if (sum > e.quantita) {
                        this.qntErr = true;
                    }
                    console.log(e.quantita);
                    console.log(sum);
                }
            });
            console.log(peso_netto);
            console.log(item.ubicazione_att_peso);
            console.log(item.ubicazione_max_peso);
            console.log(item.quantita * peso_netto);
            if (
                item.ubicazione_max_peso != null &&
                item.quantita * peso_netto + item.ubicazione_att_peso >
                    item.ubicazione_max_peso
            ) {
                this.pesoErr = true;
            } else {
                this.pesoErr = false;
            }
        },
    },
};
</script>
